// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__CSYuW","col":"Table_col__1B6Yq","fulfillmentStatus":"Table_fulfillmentStatus__2E3Mj","emailCol":"Table_emailCol__3pRLT"};